module.exports = __webpack_public_path__ + "static/media/boat2.e37c6cf4.png";